import { Table } from 'antd';

import { PREFIX } from '@app/constants';
import { EmailLogModal } from '@app/pages/EmailLogs/components';
import { useEmailLogs, useEmailLogsEffects } from '@app/pages/EmailLogs/hooks/';

import { Filters } from '@pages/EmailLogs/ui';

import '@pages/EmailLogs/styles/EmailLogs.desktop.scss';

export const EmailLogs = () => {
  const {
    onSearch,
    onReset,
    columns,
    handleGetEmailLogs,
    defaultFilters,
    defaultPage,
    defaultPageSize,
    setFilters,
    filters,
    isLoading,
    data,
    handleTableChange,
    currentLogId,
    isLogModalOpen,
    handleLogModalClose,
  } = useEmailLogs();

  useEmailLogsEffects({
    handleGetEmailLogs,
    defaultFilters,
    defaultPage,
    defaultPageSize,
  });

  return (
    <div className={`${PREFIX}email-logs`}>
      <Filters
        values={filters}
        disabled={isLoading}
        setFilters={setFilters}
        onSearch={onSearch}
        onReset={onReset}
      />

      <Table
        columns={columns}
        loading={isLoading}
        dataSource={data?.Logs || []}
        rowKey="Id"
        className="logs-table"
        pagination={{
          position: ['bottomLeft'],
          showSizeChanger: true,
          total: data?.CountItems,
          pageSize: data?.PageSize,
          onChange: handleTableChange,
        }}
      />

      <EmailLogModal
        open={isLogModalOpen}
        logId={currentLogId}
        onClose={handleLogModalClose}
      />
    </div>
  );
};
